/**
 * Action type to signal the closing of the participants pane.
 */
export const PARTICIPANTS_PANE_CLOSE = 'PARTICIPANTS_PANE_CLOSE';
/**
 * Action type to signal the opening of the participants pane.
 */
export const PARTICIPANTS_PANE_OPEN = 'PARTICIPANTS_PANE_OPEN';
/**
 * Action type to set the volume of the participant.
 */
export const SET_VOLUME = 'SET_VOLUME';
/**
 * Action type to set the frequency filter setting of the participant.
 */
export const SET_FREQUENCY_FILTER_SETTING = 'SET_FREQUENCY_FILTER_SETTING';
/**
 * Action type to set the opacity setting of the participant.
 */
export const SET_PARTICIPANT_OPACITY = 'SET_PARTICIPANT_OPACITY';
/**
 * Action type to set the zoom level of the participant.
 */
export const SET_PARTICIPANT_ZOOM_LEVEL = 'SET_PARTICIPANT_ZOOM_LEVEL';
